import { useNavigate, useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { Button, Stack } from '@mui/material';

import { ArrowBack } from '@mui/icons-material';

import PageShell from '../../components/layout/PageShell';

import PageHeader from '../../components/layout/PageHeader';

import OutstationPricingPanel from '../../components/outstation/OutstationPricingPanel';

import { ZoneMasterPicker } from '../hubs/tabs/ServiceRentalMasterTab';

import { listZones } from '../../services/zoneService';



export default function OutstationManagementPage() {

  const navigate = useNavigate();

  const { zoneCode } = useParams<{ zoneCode?: string }>();



  const { data: zoneInfo } = useQuery({

    queryKey: ['zone-by-code', zoneCode],

    queryFn: async () => {

      const res = await listZones({ limit: 200 });

      return res.rows?.find((z) => z.code === zoneCode);

    },

    enabled: !!zoneCode,

  });



  if (zoneCode) {

    const zoneTitle = zoneInfo?.name || zoneCode;

    return (

      <PageShell>

        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>

          <Button startIcon={<ArrowBack />} onClick={() => navigate('/transport/outstation-management')}>

            All Zones

          </Button>

        </Stack>

        <PageHeader

          title={`Outstation Pricing — ${zoneTitle}`}

          subtitle={`KM slab + trip type packages — all amounts in ${zoneInfo?.currency || 'INR'}. Secondary zones inherit pricing from their primary zone.`}

        />

        <OutstationPricingPanel lockedZoneCode={zoneCode} />

      </PageShell>

    );

  }



  return (

    <PageShell>

      <PageHeader

        title="Outstation Management"

        subtitle="Select a primary zone to configure outstation KM slabs and per-vehicle pricing. Secondary zones inherit pricing from their primary zone."

        gradient

      />

      <ZoneMasterPicker

        title=""

        subtitle=""

        packageCountSource="outstation"

        detailTitle={(name, code) => `Outstation Pricing — ${name} (${code})`}

        onZoneSelect={(code) => navigate(`/transport/outstation-management/${encodeURIComponent(code)}`)}

        renderDetail={(code) => (

          <OutstationPricingPanel lockedZoneCode={code} />

        )}

      />

    </PageShell>

  );

}

